export const RemitaStore = {
  namespaced: true,
  state: {
    paymentKey: null,
  },
  mutations: {
    setPaymentKey(state, key) {
      state.paymentKey = key;
    },
  },
  actions: {
    async fetchPaymentKey(context) {
      if (context.state.paymentKey) return context.state.paymentKey;
      const response = await axios.get("/remitaPaymentKey");
      context.commit("setPaymentKey", response.data.key);
      return response.data.key;
    },
    saveRRR(context, paymentData) {
      return new Promise((res, rej) => {
        axios
          .post("/addRemitaRRR", paymentData)
          .then((response) => {
            if (response.data.msg == "success") {
              res(response);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    getRRR(context, paymentDetails) {
      return new Promise((res, rej) => {
        axios
          .post("/generateRRR", {
            serviceType_id: paymentDetails.serviceType_id,
            amount: paymentDetails.amount,
            orderId: paymentDetails.orderId,
            description: paymentDetails.description,
            details: paymentDetails.details,
          })
          .then((response) => {
            if (response.data.statuscode == "025" || response.data.msg == "success") {
              res(response);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            Toast.fire({
              icon: "error",
              title: "Unable to get Remita retrieval reference",
            });
            rej(err);
          });
      });
    },

    async makePayment(context, paymentDetails) {
      const key = paymentDetails.key || await context.dispatch("fetchPaymentKey");
      return new Promise((res, rej) => {
        try {
          var paymentEngine = RmPaymentEngine.init({
            key: key,
            customerId: context.rootState.User.id,
            fullname: context.rootState.User.fullname,
            email: context.rootState.User.email,
            amount: paymentDetails.amount,
            rrr: paymentDetails.rrr,
            processRrr: true,
            extendedData: {
              customFields: [
                {
                  name: "rrr",
                  value: paymentDetails.rrr,
                },
              ],
            },
            onSuccess: (response) => {
              res(response);
            },
            onError: (response) => {
              rej(response);
            },
            onClose: function () {},
          });
          paymentEngine.showPaymentWidget();
        } catch (error) {
          Toast.fire({
            icon: "error",
            title: "Connection to remita failed",
          });
        }
      });
    },

    UpdateTransaction(context, paymentDetails) {
      return new Promise((res, rej) => {
        axios
          .post("/updateTransaction", paymentDetails)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    checkPaymentStatus(context, paymentDetails) {
      return new Promise((res, rej) => {
        axios
          .post("checkRRRStatus", { rrr: paymentDetails })
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    async checkAndUpdatePayment(context, { response, details }) {
      try {
        if (response.status == "02") {
          await context.dispatch("UpdateTransaction", { ...details, status: "FAILED" });
        } else if (response.status == "00" || response.status == "01") {
          await context.dispatch("UpdateTransaction", { ...details, status: "SUCCESS" });
        } else if (response.status == "021" && details.status !== "pending") {
          await context.dispatch("UpdateTransaction", { ...details, status: "PENDING" });
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    checkRRRStatus(context, rrr) {
      return new Promise((res, rej) => {
        axios
          .post("checkRRRStatus", { rrr: rrr })
          .then(async (response) => {
            Toast.fire({
              icon: "info",
              title: response.data.message,
            });
            if (response.data.status == "00" || response.data.status == "01") {
              await context.dispatch("UpdateTransaction", {
                paymentReference: rrr,
                amount: response.data.amount,
              });
            }
            res(response);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    updatePaymentStatus(context, { payment, status, remitaResponse }) {
      return new Promise((res, rej) => {
        axios
          .post("updatePaymentStatus", { payment, status, remitaResponse })
          .then((response) => res(response))
          .catch((err) => rej(err));
      });
    },
  },
};
